import React from 'react';
import styled from 'styled-components';

interface TagItemProps {
  tag: string;
  isAddButton?: boolean;
  onRemove?: () => void;
  onClick?: (e: React.MouseEvent) => void;
}

// タグ
const Tag = styled.div<{ $color: string; $isAddButton?: boolean }>`
  padding: 2px 5px;
  background-color: ${props => props.$color};
  border-radius: 3px;
  font-size: 12px;
  display: flex;
  align-items: center;
  ${props => props.$isAddButton && `
    cursor: pointer;
    border: 1px dashed #999;
    background-color: transparent;
    &:hover {
      background-color: #f0f0f0;
    }
  `}
`;

// タグ削除ボタン
const TagRemove = styled.span`
  margin-left: 3px;
  cursor: pointer;
  font-weight: bold;
`;

const TagItem: React.FC<TagItemProps> = ({ 
  tag, 
  isAddButton, 
  onRemove, 
  onClick 
}) => {
  return (
    <Tag 
      $color="#e0e0e0" 
      $isAddButton={isAddButton}
      onClick={onClick}
    >
      {tag}
      {onRemove && (
        <TagRemove onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}>
          ×
        </TagRemove>
      )}
    </Tag>
  );
};

export default TagItem; 